import { axiosClient } from "./axiosClient";

export interface ApiKey {
  id: string;
  name: string;
  token_prefix: string;
  last_used_at: string | null;
  revoked_at: string | null;
  revoked: boolean;
  created_at: string;
}

// Samodzielne zarządzanie kluczami publicznego API (panel „Developer"). Gated `api_access` po stronie backendu.
export const listApiKeys = () => axiosClient.get<{ api_keys: ApiKey[] }>("api_keys");

// Tworzenie zwraca plaintext klucza RAZ (pole `token`) — backend trzyma tylko skrót.
export const createApiKey = (name?: string) =>
  axiosClient.post<{ api_key: ApiKey & { token: string } }>("api_keys", { name });

export const revokeApiKey = (id: string) => axiosClient.delete(`api_keys/${id}`);

// Bazowy URL publicznego API (do dokumentacji/embedu) — z tego samego hosta co backend.
export const publicApiBaseUrl = (): string =>
  `${process.env.REACT_APP_BACKEND_URL ?? ""}/api/public/v1`;
